import FAQPanel from '#root/components/FAQPanel';
import type { FAQItem } from '#root/components/FAQPanel';
import { Timeline } from '#root/components/ui';
import styles from './shipmentInfoPanel.module.scss';

const faqs: FAQItem[] = [
  {
    id: 'proceso',
    question: '¿Cómo funciona el proceso de envío?',
    answer: (
      <Timeline
        items={[
          'El viajero entrega tu pedido en una oficina autorizada (MBE)',
          'Te notificamos para que confirmes tu envío (dirección o recojo)',
          'MBE embala y registra tu envío',
          'Realizas el pago del envío',
          'OLVA Courier entrega en tu dirección',
        ]}
      />
    ),
  },
  {
    id: 'tiempos',
    question: '¿Cuánto tiempo demora la entrega?',
    answer: (
      <>
        <ul>
          <li>
            <strong>Lima Metropolitana:</strong> 1-2 días hábiles
          </li>
          <li>
            <strong>Costa:</strong> 2-3 días hábiles
          </li>
          <li>
            <strong>Sierra y Selva:</strong> 3-5 días hábiles
          </li>
        </ul>
        <p>
          <small>* Tiempos contados desde que el envío es despachado</small>
        </p>
      </>
    ),
  },
  {
    id: 'tracking',
    question: '¿Cómo hago seguimiento de mi envío?',
    answer: (
      <>
        <p>Una vez despachado, recibirás un código de tracking por email.</p>
        <p>
          Puedes seguir tu envío en:{' '}
          <a href="https://tracking.olvaexpress.pe/" target="_blank" rel="noopener noreferrer">
            https://tracking.olvaexpress.pe/
          </a>
        </p>
      </>
    ),
  },
  {
    id: 'valorizacion',
    question: '¿Qué es la Valorización y el seguro?',
    answer: (
      <>
        <p className={styles.reassurance}>✓ Más del 99% de envíos llegan sin problemas</p>
        <p>
          La valorización es el valor declarado de tu envío, que determina la cobertura del seguro
          de transporte.
        </p>
        <ul>
          <li>
            <strong>Recomendado</strong> para pedidos mayores a S/ 500
          </li>
          <li>
            <strong>Obligatorio</strong> para envíos de más de S/ 1,000
          </li>
          <li>Puedes asegurar por un monto menor al total</li>
        </ul>
        <div className={styles.ratesBox}>
          <span className={styles.ratesTitle}>
            Tarifas (fijadas por OLVA, según el valor total del envío):
          </span>
          <ul>
            <li>S/ 100 – S/ 3,000 → 0.6 %</li>
            <li>Más de S/ 3,000 → 2 %</li>
          </ul>
        </div>
        <p>
          <small>
            El seguro cubre hasta el 95% del valor declarado. El costo total de envío incluye:
            embalaje + flete + seguro.
          </small>
        </p>
      </>
    ),
  },
  {
    id: 'recojo',
    question: '¿Puedo recoger mi envío en persona?',
    answer: (
      <>
        <p>Sí, puedes recoger tu envío en persona:</p>
        <Timeline
          variant="numbered"
          items={[
            'Selecciona "Recoger en persona" al confirmar tu envío',
            'Registra nombre completo y documento (DNI/CE) de quien recoge',
            'Te indicaremos la oficina y horarios disponibles',
            'La persona deberá presentar su documento de identidad',
          ]}
        />
        <p>
          <small>
            * El recojo no tiene costo y debe hacerse dentro de los 7 días siguientes a que el
            viajero entregue tu pedido en la oficina.
          </small>
        </p>
      </>
    ),
  },
  {
    id: 'consolidacion',
    question: '¿Puedo consolidar envíos?',
    answer: (
      <p>
        Es poco probable que puedas consolidar envíos, ya que cada viajero entrega pedidos en
        oficinas diferentes; adicionalmente las oficinas solo pueden mantener paquetes por un
        tiempo limitado.
      </p>
    ),
  },
];

const ShipmentInfoPanel = () => {
  return (
    <div className={styles.root}>
      <FAQPanel
        faqs={faqs}
        subtitle="Mis Envíos"
        teaserText="Información importante sobre envíos, tiempos o valorización."
      />
    </div>
  );
};

export default ShipmentInfoPanel;
